// Plain-language labels for the AI pre-review saved on a submission (submission.aiReview).
export const FLAG_LABELS = {
    not_relevant: "Not related to the challenge",
    internet_or_stock: "Looks like an internet / stock photo",
    ai_generated: "Looks AI-generated",
    screenshot: "Screenshot",
    no_face: "Selfie required but no face",
    duplicate_suspected: "Possible duplicate",
    gibberish_text: "Meaningless text",
};

export const VERDICT_LABELS = { approve: "Approve", reject: "Reject", unsure: "Unsure" };

export const verdictColor = (verdict) => (verdict === "approve" ? "green" : verdict === "reject" ? "red" : "inactive");

// What the AI suggests for the WHOLE submission, after the per-answer rules (faces, unsure answers, rejected answers).
// "Approve" only when every answer passed; otherwise say so, so a high % is not mistaken for a full approval.
export function aiSuggestionLabel(ai) {
    const s = ai && ai.suggestion && ai.suggestion.overall && ai.suggestion.overall.verdict;
    if (s === "approve") return { text: "Approve", color: "green" };
    if (s === "approve_partly") return { text: "Partly approve", color: "yellow" };
    if (s === "needs_review") return ai.verdict === "approve" ? { text: "Approve, check answers", color: "yellow" } : { text: "Unsure", color: "inactive" };
    if (s === "reject") return { text: "Reject", color: "red" };
    return { text: VERDICT_LABELS[ai.verdict] || ai.verdict, color: verdictColor(ai.verdict) };
}

// What the AI did, in one line.
export function aiStatusText(ai) {
    if (!ai || !ai.status) return null;
    if (ai.status === "processing") return "AI review in progress";
    if (ai.status === "error") return "AI review failed";
    if (ai.actionStatus === "done" && ai.action === "approve") return "Auto-approved by AI";
    if (ai.actionStatus === "done" && ai.action === "reject") return "Auto-rejected by AI";
    if (ai.actionStatus === "failed") return `AI tried to auto-${ai.action}, needs manual review`;
    return `AI suggests: ${aiSuggestionLabel(ai).text} (${ai.confidence}%)`;
}
